export const defaultFonts = ['Open Sans', 'DejaVu Sans'];